module.exports = __webpack_public_path__ + "img/korzina.ac9bfa6.svg";